import { approvalActionNames } from '../utils/AntApprovalActions';
import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';
import AntGridScope, { buildGridScopeSegment } from './AntGridScope';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { unpack, pack } from 'msgpackr';
import stringify from '../utils/stableStringify';
// import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { useReactToPrint } from 'react-to-print';
import format from 'string-format';
import { LoadPanel } from 'devextreme-react/load-panel';
import AntCondition from '../utils/AntCondition';
import AntConfig from '../utils/AntConfig';
import AntTime from '../utils/AntTime';
import AntLocalization from '../utils/AntLocalization';
import AntPage from './AntPage';
import AntToolbar from './AntToolbar';
import AntBaseForm from './AntBaseForm';
import AntVoucherTabs from './AntVoucherTabs';
import AntErrorPage from './AntErrorPage';
import AntVoucherSkeleton from './AntVoucherSkeleton';
import { markVoucherViewed, shouldShowBootSkeleton, bootKeyOf } from './AntVoucherSkeleton/bootTracker';
import AntErrorPanel from './AntErrorPanel';
import AntInfoPanel from './AntInfoPanel';
import AntMessageBox from './AntMessageBox';

import AntPrinting from './AntPrinting';
import AntVoucherFlow from './AntVoucherFlow';
import AntLeftSidebar from './AntLeftSidebar';
import AntAIVoucherAnalyzer from './AntAIVoucherAnalyzer';
import { getDrilldown } from './AntVoucherFlow/flow-config';

import AntAuth from '../utils/AntAuth';
import AntAPI from '../utils/AntAPI';
import { applyPreparedSnapshot } from '../utils/AntSnapshotTransport';
import cs from '../utils/const';

import { AntGlobal, AntSession, AntSidebarContext } from '../utils/AntContext';

// import { useOneTimeEffect } from '../hooks';

export default forwardRef(function (props, ref) {
    const appGlobal = AntGlobal();
    const session = AntSession();
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    // Ref luôn giữ params MỚI NHẤT (mã phiếu đang mở). Mọi reload bất đồng bộ (socket/timer)
    // đọc mã từ đây thay vì closure — tránh timer/callback cũ reload NHẦM về phiếu đã đóng.
    const paramsRef = useRef(params);
    paramsRef.current = params;

    const locationPath = String(location.pathname);

    if (props.API && !props.API.entityDisplay) {
        if (appGlobal && appGlobal.appConfig && appGlobal.appConfig.Services) {
            let found = appGlobal.appConfig.Services.find((s) => s.name === props.API.entityName);
            if (found) props.API.init({ entityDisplay: found.display });
        }
    }

    const mainTable = props.table ? props.table : props.API ? props.API.entityName : '';
    const mainEntityName = props.API && props.API.entityName ? props.API.entityName : '';
    const mainEntityDisplay = props.API && props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay ? props.entityDisplay : '';

    const mainConfig = useMemo(() => {
        let found = appGlobal.tableConfigs?.find((t) => t.tableName === mainTable);
        if (found) return found.config;

        let cnf = new AntConfig(appGlobal, mainTable);
        // cnf.configFields(props.fields);

        if (appGlobal.tableConfigs instanceof Array === false) appGlobal.tableConfigs = [];

        appGlobal.tableConfigs.push({
            tableName: mainTable,
            config: cnf
        });
        return cnf;
    }, []);

    const [mainData, setMainData] = useState({});
    const mainDataRef = useRef(mainData);
    mainDataRef.current = mainData;
    // Chống nháy + chống bản cũ đè bản mới khi socket dồn dập (POS thêm SP liên tục):
    // loadSeqRef = số thứ tự lượt load (response cũ về muộn bị bỏ);
    // dataVersionRef = updated_at đang hiển thị (payload/response cũ hơn bị bỏ);
    // socketReloadTimerRef = debounce client 400ms gộp nhiều sự kiện thành 1 lần reload.
    const loadSeqRef = useRef(0);
    const dataVersionRef = useRef(null);
    const socketReloadTimerRef = useRef(null);
    const mainCode = useRef(null);
    const mainID = useRef(null);
    const aiAnalyzerRef = useRef(null);
    const leftSidebarRef = useRef(null);
    const voucherContentRef = useRef(null);

    const showAIAnalyzer = useCallback(
        (opts) => {
            if (aiAnalyzerRef.current && aiAnalyzerRef.current.start) {
                aiAnalyzerRef.current.start(opts || {});
            }
        },
        []
    );

    // ─── Sidebar context ─────────────────────────────────────────
    const sidebarContext = useMemo(
        function () {
            if (!mainData || !mainData.id) return null;
            var hasAI = !!(mainData.aiExtract && mainData.aiExtract.enabled);
            return {
                voucherType: mainEntityName,
                voucherTypeLabel: mainEntityDisplay,
                voucherModule: props.API ? props.API.moduleName : null,
                voucherCode: mainData.code,
                voucherId: mainData.id,
                data: mainData,
                session: session,
                voucherActions: hasAI ? { showAIAnalyzer: showAIAnalyzer } : undefined
            };
        },
        [mainData ? mainData.id : null, mainData ? mainData.code : null, mainEntityName, showAIAnalyzer]
    );

    // Set sidebar context
    var _sidebarCtx = React.useContext(AntSidebarContext);
    useEffect(
        function () {
            if (_sidebarCtx && _sidebarCtx.setContext) {
                _sidebarCtx.setContext(sidebarContext);
            }
            return function () {
                if (_sidebarCtx && _sidebarCtx.setContext) _sidebarCtx.setContext(null);
            };
        },
        [sidebarContext ? sidebarContext.voucherId : null, sidebarContext ? sidebarContext.voucherCode : null]
    );

    const [flowData, setFlowData] = useState(null);
    const [flowVisible, setFlowVisible] = useState(false);
    // Khung xám CHỈ dùng cho lần đầu mở MỘT phiếu (mã/số định danh đổi).
    // Mọi lượt tải lại phiếu đang xem (timer 30s, socket, sau thao tác) KHÔNG dựng lại
    // khung xám — giữ nguyên số cũ trên màn hình.
    const [bootCode, setBootCode] = useState(function () {
        var key = bootKeyOf(params);
        return shouldShowBootSkeleton(key) ? key : null;
    });
    const [mainState, setMainState] = useState({
        error: null,
        tabStyle: 'Collapse',
        oldData: null,
        loading: true,
        toolbarProcessingButton: null
    });

    const mainInfos = useMemo(() => {
        let ar = [];
        if (mainData && mainData.infos instanceof Array && mainData.infos.length > 0) {
            if (props.onProcessInfo) ar = props.onProcessInfo(mainData.infos);
            else ar = mainData.infos;
        }
        return ar;
    }, [mainData]);

    // Giữ reference ổn định khi chỉ trạng thái tải của phần nội dung phiếu thay đổi.
    // AntLeftSidebar nằm ngoài content động và chỉ nhận dữ liệu mới khi chính phiếu/flow đổi.
    const leftSidebarData = useMemo(
        () => ({
            summary: mainData,
            flowData: flowData,
            entityName: mainEntityName,
            entityDisplay: mainEntityDisplay
        }),
        [mainData, flowData, mainEntityName, mainEntityDisplay]
    );

    const isPrepared = useRef(false);
    const isValidated = useRef(false);
    const isSaving = useRef(false);
    const autoReloadTimer = useRef();
    const quickReloadTimeOut = useRef();

    const header = useRef();
    const footer = useRef();
    const tabs = useRef();
    const msgBox = useRef();
    const printer = useRef();

    const isRenderPage = useMemo(() => AntCondition.isRender(mainData, props), [mainData]);

    const isVisiblePage = Boolean(mainData && mainID.current);
    const isVisibleHeader = useMemo(
        () => props.header && props.header.items?.length > 0 && AntCondition.isVisible(mainData, props.header),
        [mainData]
    );
    const isVisibleFooter = useMemo(
        () => props.footer && (props.footer.items?.length > 0 || props.footer.renderFooter) && AntCondition.isVisible(mainData, props.footer),
        [mainData]
    );

    const isInValidData = useMemo(() => (mainID.current || mainCode.current) && mainData && !mainID.current, [mainState, mainData]);

    const sessionValid = useMemo(() => {
        let _canRender = true;

        if (props.table === 'ACUserAccount') {
            _canRender = AntCondition.isValid(null, {
                whenSession: {
                    session_status: { type: '!=', value: 'Restricted' },
                    user_group_code: 'Admin'
                },
                whenSessionType: 'OR'
            });
        } else {
            _canRender = AntCondition.isValid(null, {
                whenSession: {
                    session_status: { type: '!=', value: 'Restricted' }
                }
            });
        }

        return _canRender;
    }, []);

    const isPermDeniedData = useMemo(
        () => sessionValid && (mainID.current || mainCode.current) && mainData && mainData.errorCode === cs.erPermissionDenied.code,
        [mainState, mainData, sessionValid]
    );

    // Khung xám thay cho vòng xoay: chỉ khi đang mở phiếu mới và chưa có dữ liệu.
    const renderBootSkeleton = Boolean(isRenderPage && !isPermDeniedData && bootCode && !mainState.error);
    const renderLoading = isRenderPage && !isPermDeniedData && (mainState.loading || !isPrepared.current);
    const renderAccessDenied = !isRenderPage || isPermDeniedData;
    const renderNotExistData = isRenderPage && !isPermDeniedData && !renderLoading && isPrepared.current && isInValidData;

    let isRender = props.shouldRender ? props.shouldRender : 1;

    const showAlert = useCallback((args, onClosedCallback) => {
        if (msgBox.current) msgBox.current.show(args, onClosedCallback);
    }, []);

    const setError = useCallback(
        (content, errors) => {
            if (!content && (mainState.error === null || mainState.error === undefined)) return;
            if (errors == 'TypeError: Failed to fetch')
                errors = {
                    vi: 'Không thể kết nối đến hệ thống !',
                    en: 'Can not connect to system !',
                    fr: 'Impossible de se connecter au système !',
                    es: '¡No se puede conectar al sistema!',
                    id: 'Tidak dapat terhubung ke sistem!',
                    ja: 'システムに接続できません！',
                    zh: '无法连接到系统！',
                    ko: '시스템에 연결할 수 없습니다!',
                    hi: 'सिस्टम से कनेक्ट नहीं हो सकता!',
                    ar: 'لا يمكن الاتصال بالنظام!'
                };

            var values = errors === undefined || errors === null ? [] : errors instanceof Array ? errors : [errors];

            content = values.length === 1 ? values[0] : content;

            setMainState((v) =>
                Object.assign(v, {
                    error: content
                        ? {
                              text: String(content),
                              values: values
                          }
                        : null
                })
            );

            if (props.onError) props.onError(content, errors);
        },
        [mainState, props.onError]
    );

    const showPopup = useCallback(
        (ref, withMain, defaultObj) => {
            if (!ref) return;

            var obj = {};
            if (defaultObj && typeof defaultObj === 'object') obj = { ...obj, ...defaultObj };

            if (!withMain) {
                if (ref.show) ref.show(obj);
                else if (ref.current && ref.current.show) ref.current.show(obj);
                return;
            }

            var code = mainCode.current;
            var id = mainID.current;
            if (id || code) {
                var main = mainData;
                if (main && typeof main === 'object') obj = { ...main, ...obj };

                if (ref.show) ref.show(obj);
                else if (ref.current && ref.current.show) ref.current.show(obj);
            }
        },
        [mainData]
    );

    const onHomeClick = useCallback(() => {
        var link;
        if (props.homeUrl) {
            link = props.homeUrl;
        } else {
            link = String(locationPath);
            var ar = link.split('/');
            if (ar.length > 0) ar.pop();
            link = ar.join('/');
            if (!link.startsWith('/')) link = '/' + link;
            link = link + 's';
        }

        if (autoReloadTimer.current) clearInterval(autoReloadTimer.current);
        navigate(link);
    }, [props.homeUrl, locationPath]);

    const navigateToReload = useCallback(
        (id, code) => {
            if (quickReloadTimeOut.current) clearTimeout(quickReloadTimeOut.current);

            var link = String(locationPath);
            var ar = link.split('/');
            if (ar.length > 0) ar.pop();
            link = ar.join('/');
            if (!link.startsWith('/')) link = '/' + link;
            if (!link.endsWith('/')) link = link + '/';
            link = format('{0}{2}', link, null, code ? code : id);

            if (autoReloadTimer.current) clearInterval(autoReloadTimer.current);

            navigate(link);
        },
        [locationPath]
    );

    const onActionQuickCreate = useCallback(async () => {
        var result = await props.API.postQuickCreate();
        if (result && result.error) {
            showAlert({
                content: result.error
            });
        } else {
            if (result.data) {
                var code = result.data.code;
                var id = result.data.id;
                navigateToReload(id, code);
            }
        }
    }, [props.API, showAlert, navigateToReload]);

    const onActionClone = useCallback(async () => {
        var result = await props.API.postClone(mainCode.current, mainID.current);
        if (result && result.error) {
            showAlert({
                content: result.error
            });
        } else {
            if (result.data) {
                var code = result.data.code;
                var id = result.data.id;

                navigateToReload(id, code);
            }
        }
    }, [props.API, showAlert, navigateToReload]);

    const onActionUpdateWithDoc = useCallback(async () => {
        if (_sidebarCtx && _sidebarCtx.openLeftPanel) _sidebarCtx.openLeftPanel('aiWizard');
        showAIAnalyzer({ mode: 'new' });
    }, [showAIAnalyzer, _sidebarCtx]);

    const handlePrint = useReactToPrint({
        content: () => {
            if (props.printComponent) return props.printComponent.current;
            if (props.printUrl) return printer.current;
        }
    });

    const validate = useCallback(async () => {
        isValidated.current = true;
        var isOK = true;

        if (header.current) {
            var isValid = await header.current.validate();
            if (!isValid) isOK = false;
        }

        if (header.current) {
            var isValid = await footer.current.validate();
            if (!isValid) isOK = false;
        }

        if (tabs.current) {
            var isValid = await tabs.current.validate();
            if (!isValid) isOK = false;
        }

        return isOK;
    }, []);

    const getValidData = useCallback(
        async (byPassValidate) => {
            if (!byPassValidate) if (!(await validate())) return null;

            var obj = {};

            Object.keys(mainData).forEach(function (fieldName) {
                if (['actions', 'edit', 'infos', 'checksum', 'recalc_checksum', 'updated_at'].includes(fieldName)) return;

                var objCurrent = mainData[fieldName];
                var objOld = mainState.oldData ? mainState.oldData[fieldName] : null;

                if (
                    objCurrent !== objOld &&
                    stringify(objCurrent) !== stringify(objOld) &&
                    (!['', null].includes(objCurrent) || !['', null].includes(objOld))
                )
                    obj[fieldName] = objCurrent;
            });

            return obj;
        },
        [validate, mainData, mainState]
    );

    const applyVoucherFlow = useCallback(
        (data) => {
            if (!props.flow || !data || !Object.prototype.hasOwnProperty.call(data, 'voucherFlow')) return false;
            if (mainCode.current && data.code && data.code !== mainCode.current) return false;
            if (mainID.current && data.id && String(data.id) !== String(mainID.current)) return false;
            if (data.updated_at && dataVersionRef.current && data.updated_at < dataVersionRef.current) return false;
            var nextFlow = data.voucherFlow || null;
            var hasData = nextFlow && nextFlow.nodes && nextFlow.nodes.length > 1;
            setFlowData(nextFlow);
            setFlowVisible(Boolean(hasData && props.flow.display === 'always'));
            return true;
        },
        [props.flow]
    );

    const applyPreparedPayload = useCallback((d) => {
        var prepared = applyPreparedSnapshot(mainDataRef.current, d);
        if (!prepared) return false;
        if (mainCode.current && prepared.code && prepared.code !== mainCode.current) return false;
        if (mainID.current && prepared.id && String(prepared.id) !== String(mainID.current)) return false;
        if (prepared.updated_at && dataVersionRef.current && prepared.updated_at < dataVersionRef.current) return false;

        applyVoucherFlow(prepared);
        delete prepared.voucherFlow;

        var edit = prepared.edit && typeof prepared.edit === 'object' ? prepared.edit : {};
        var snapshot = {
            ...prepared,
            edit: {
                ...edit,
                always_editable_fields: [...new Set([...(edit.always_editable_fields || []), 'code'])],
                none_validate_fields: [...new Set([...(edit.none_validate_fields || []), 'code'])]
            }
        };
        var snapshotSerialized = stringify(snapshot);

        loadSeqRef.current = (loadSeqRef.current || 0) + 1;
        if (snapshot.updated_at) dataVersionRef.current = snapshot.updated_at;
        isPrepared.current = true;
        mainCode.current = snapshot.code;
        mainID.current = snapshot.id;
        var previousSnapshot = mainDataRef.current;
        mainDataRef.current = snapshot;
        if (stringify(previousSnapshot) === snapshotSerialized) tabs.current?.invalidateGrids?.();
        setMainData((current) => (stringify(current) === snapshotSerialized ? current : snapshot));
        setMainState((state) => {
            if (!state.error && !state.loading && stringify(state.oldData) === snapshotSerialized) return state;
            return { ...state, error: null, loading: false, oldData: JSON.parse(snapshotSerialized) };
        });
        return true;
    }, [applyVoucherFlow]);

    const loadContent = useCallback(
        async (opts) => {
            if (!props.API || !props.API.postUpdatePrepare) return;

            // Lấy mã từ ref luôn-mới (KHÔNG từ closure) → reload luôn trúng phiếu đang mở,
            // kể cả khi hàm này bị 1 timer/callback cũ gọi lại sau khi user đã đổi phiếu.
            var p = paramsRef.current || params;
            var id = p && p.id ? p.id : undefined;
            var code = p && p.code ? p.code : undefined;
            if (!code && !id) return;

            if (
                opts &&
                opts.changedFields &&
                props.refreshOnChangedFields &&
                !opts.changedFields.some((f) => props.refreshOnChangedFields.includes(f))
            )
                return;

            // Chốt thứ tự: nhiều loadContent chồng nhau (socket dồn + user thao tác nhanh)
            // → chỉ response của lượt gọi MỚI NHẤT được áp; response cũ về muộn bị bỏ,
            // hết cảnh "đơn hiển thị dữ liệu cũ đè dữ liệu cuối".
            loadSeqRef.current = (loadSeqRef.current || 0) + 1;
            var mySeq = loadSeqRef.current;

            var obj = opts && opts.newObj ? opts.newObj : null;

            if (!opts || !opts.isRefresh) isPrepared.current = false;

            let prepareOpts = { ...props.prepareConditions, ...props.header?.prepareConditions };
            if (opts?.forcePrepare) prepareOpts.forcePrepare = true;
            if (props.isSetting) prepareOpts.isSetting = true;

            obj = await props.API.postUpdatePrepare(
                id,
                code,
                Boolean(opts && typeof obj === 'object' && opts.recalcable),
                prepareOpts,
                opts?.bypassSnapshot ? undefined : mainDataRef.current
            );

            // Response cũ về muộn (đã có lượt gọi mới hơn) → bỏ
            if (mySeq !== loadSeqRef.current) return;

            // BE lỗi → postUpdatePrepare resolve { error, code } (object TRUTHY). KHÔNG coi là prepared:
            // giữ isPrepared=false → renderParent=false → toolbar ẩn mọi action, chỉ còn Refresh để thử lại.
            // (Trước đây obj truthy → chạy nhánh success → isPrepared=true → hiện hết action.)
            if (obj && obj.error) {
                setBootCode(null);
                setMainState((v) => Object.assign(v, { error: obj.error, loading: false }));
                return obj;
            }

            if (obj) {
                if (!obj.edit) obj.edit = {};

                var ar1 = [];
                if (obj.edit.always_editable_fields && obj.edit.always_editable_fields instanceof Array) ar1.push(...obj.edit.always_editable_fields);
                if (!ar1.includes('code')) ar1.push('code');

                var ar2 = [];
                if (obj.edit.none_validate_fields && obj.edit.none_validate_fields instanceof Array) ar2.push(...obj.edit.none_validate_fields);
                if (!ar2.includes('code')) ar2.push('code');

                obj.edit = {
                    ...obj.edit,
                    always_editable_fields: ar1,
                    none_validate_fields: ar2
                };

                // Bản dữ liệu CŨ hơn bản đang hiển thị (socket đã cập nhật mới hơn) → bỏ
                if (obj.updated_at && dataVersionRef.current && obj.updated_at < dataVersionRef.current) {
                    isPrepared.current = true;
                    setBootCode(null);
                    setMainState((v) => Object.assign(v, { loading: false }));
                    return obj;
                }
                if (obj.updated_at) dataVersionRef.current = obj.updated_at;

                setMainData((v) => {
                    if (stringify(v) === stringify(obj)) return v;
                    let newData = JSON.parse(stringify(v));

                    Object.keys(newData).forEach((key) => {
                        delete newData[key];
                    });

                    return Object.assign(newData, obj);
                });

                isPrepared.current = true;
                mainCode.current = obj.code;
                mainID.current = obj.id;

                // Extract voucherFlow from updatePrepare response
                if (props.flow && obj.voucherFlow) {
                    let vf = obj.voucherFlow;
                    let hasData = vf && vf.nodes && vf.nodes.length > 1;
                    setFlowData(vf);
                    setFlowVisible(hasData && props.flow.display === 'always');
                    delete obj.voucherFlow;
                }

                if (opts?.refreshChildrenOnUnchanged && stringify(mainDataRef.current) === stringify(obj)) {
                    tabs.current?.invalidateGrids?.();
                }

                setBootCode(null);
                markVoucherViewed(obj.code || obj.id);
                setMainState((v) =>
                    Object.assign(v, {
                        error: null,
                        loading: false,
                        oldData: JSON.parse(stringify(obj))
                    })
                );

                // Notify BrowsePanel in left sidebar so it can refresh the current row
                // (status/totals may have changed after recalculate) without reloading the entire list.
                if (leftSidebarRef.current && typeof leftSidebarRef.current.refreshBrowseRow === 'function' && obj.code) {
                    leftSidebarRef.current.refreshBrowseRow(obj.code, obj);
                }
            }
            return obj;
        },
        [params, props.API, props.refreshOnChangedFields, props.prepareConditions, props.isSetting, props.flow]
    );

    // Chốt an toàn: máy chủ không trả sau 20 giây thì bỏ khung xám, tránh treo mãi.
    useEffect(() => {
        if (!bootCode) return;
        var timer = setTimeout(() => setBootCode(null), 20000);
        return () => clearTimeout(timer);
    }, [bootCode]);

    const onToggleFlow = useCallback(() => {
        setFlowVisible((prev) => !prev);
    }, []);

    const saveOnFieldDataChanged = useCallback(async () => {
        // if (isSaving.current) return;

        setError(null);

        var newObj = await getValidData(true);
        if (!newObj || Object.keys(newObj).length <= 0) return;

        if (props.onSaving) newObj = props.onSaving(mainData, newObj);

        isSaving.current = true;
        var error = null;

        let opts = {
            getNewPrepare: true
        };
        let whereObj = { id: mainID.current, checksum: mainData.checksum };

        if (props.isSetting) {
            opts.isSetting = true;
            whereObj.isSetting = true;
        }

        var result = await props.API.postUpdate(whereObj, newObj, opts, mainDataRef.current);
        if (!result || result.error || !result.data || !result.data.updated) error = mainConfig.translateFirstError(result);
        else {
            await loadContent({
                changedFields: Object.keys(newObj),
                // recalcable: true,
                newObj: result.data
            });
        }

        isSaving.current = false;

        if (error) {
            let strEnd = AntLocalization.translateText({
                vi: 'Không thể cập nhật thông tin !',
                en: 'Can not update data !',
                fr: 'Impossible de mettre à jour !',
                es: '¡No se puede actualizar!',
                id: 'Tidak dapat memperbarui!',
                ja: '更新できません！',
                zh: '无法更新！',
                ko: '업데이트 불가!',
                hi: 'अपडेट नहीं कर सकते!',
                ar: 'لا يمكن التحديث!'
            });

            setError(strEnd, error);
            if (props.onError) props.onError(strEnd, error);
            return false;
        } else if (props.onSaved) props.onSaved(result.data);
    }, [setError, getValidData, mainData, mainConfig, loadContent, props.onSaving, props.onSaved, props.isSetting, props.API, props.onError]);

    // Component (vd AntImageUrl/AntImageUrlList) upload xong nhận response giống actionUpdatePrepare:
    //   { code, data: {full record} }
    // → set lại mainData từ result.data để form refresh không cần gọi lại API.
    const handleUploaded = useCallback((result) => {
        if (!result || !result.data) return;
        setMainData((v) => {
            let newData = JSON.parse(stringify(v));
            Object.keys(newData).forEach((key) => {
                if (['lookups'].includes(key) === false) delete newData[key];
            });
            return Object.assign(newData, result.data);
        });
    }, []);

    const onFieldDataChanged = useCallback(
        async (e) => {
            if (e.code) {
                var code = e.code;
                navigateToReload(null, code);
                return;
            }

            if (e.id) {
                var id = e.id;
                navigateToReload(id, null);
                return;
            }

            if (props.onFieldDataChanged) {
                var isValid = props.onFieldDataChanged(e);
                if (!isValid) return;
            }

            await saveOnFieldDataChanged();
        },
        [navigateToReload, props.onFieldDataChanged, saveOnFieldDataChanged]
    );

    const loadWhenHasNewData = useCallback(async () => {
        var p = paramsRef.current || params;
        var id = p && p.id ? p.id : undefined;
        var code = p && p.code ? p.code : undefined;

        if (!code && !id) return false;

        var hadNew = false;
        try {
            if (header.current) {
                hadNew = await header.current.isHadNewData(id, code);
            }
        } catch (error) {}
        if (hadNew) {
            await loadContent();
        }

        return hadNew;
    }, [params, loadContent]);

    const autoSmartReload = useCallback(
        async (loadNow, callTime = 0) => {
            if (callTime > 5) return;

            if (quickReloadTimeOut.current) clearTimeout(quickReloadTimeOut.current);

            var hadNew = false;
            if (loadNow) {
                await loadContent(props.flow ? { recalcable: true, isRefresh: true, forcePrepare: true, bypassSnapshot: true } : undefined);
                hadNew = true;
            } else {
                hadNew = await loadWhenHasNewData();
            }

            quickReloadTimeOut.current = setTimeout(
                (timeQty) => {
                    autoSmartReload(false, timeQty ? timeQty + 1 : 1);
                },
                hadNew ? 5000 : 15000,
                callTime
            );
        },
        [loadContent, loadWhenHasNewData, props.flow]
    );

    const reload = useCallback(
        async (opts) => {
            // var tabs =
            //     props.tabs instanceof Array
            //         ? props.tabs.filter((tab) => {
            //               return AntCondition.isVisible(mainData, tab);
            //           })
            //         : [];

            if (
                (opts && opts.refreshMode === 'allPage') ||
                props.refreshMode === 'allPage'
                //  && tabs.length === 1 && props.tabs.filter((tab) => tab.visible !== undefined).length > 0
            ) {
                if (autoReloadTimer.current) clearInterval(autoReloadTimer.current);

                navigate(`/reload`, { replace: true });

                setTimeout(() => {
                    if (autoReloadTimer.current) clearInterval(autoReloadTimer.current);
                    navigate(locationPath, { replace: true });
                });
            } else {
                await loadContent(opts);
            }
        },
        [props.refreshMode, loadContent, locationPath, params]
    );

    // ─── Refresh GỘP sau khi sửa dòng trong grid (thêm/sửa/xoá sản phẩm) ──
    // Trước đây onDataSourceEdited={reload} → loadContent xoá sạch mainData rồi gán lại
    // → MỌI vùng (kể cả grid sản phẩm vừa thao tác) remount → màn nháy theo từng dòng thêm.
    // Bản gộp: vẫn gọi updatePrepare (lấy tổng + actions + edit config mới) nhưng MERGE
    // vào mainData — header/footer/toolbar cập nhật, grid giữ nguyên (grid tự quản dòng
    // nó vừa thêm). Có chốt thứ tự + chặn bản cũ như loadContent.
    const refreshVoucherSummary = useCallback(
        async () => {
            if (!props.API || !props.API.postUpdatePrepare) return;
            var id = params && params.id ? params.id : undefined;
            var code = params && params.code ? params.code : undefined;
            if (!code && !id) return;

            loadSeqRef.current = (loadSeqRef.current || 0) + 1;
            var mySeq = loadSeqRef.current;

            let prepareOpts = { ...props.prepareConditions, ...props.header?.prepareConditions };
            if (props.isSetting) prepareOpts.isSetting = true;

            var obj = await props.API.postUpdatePrepare(id, code, true, prepareOpts, mainDataRef.current);
            if (mySeq !== loadSeqRef.current) return;
            if (!obj || obj.error) return;
            if (obj.updated_at && dataVersionRef.current && obj.updated_at < dataVersionRef.current) return;
            if (obj.updated_at) dataVersionRef.current = obj.updated_at;

            applyVoucherFlow(obj);
            delete obj.voucherFlow;

            // Chuẩn hoá edit config y hệt loadContent (always_editable/none_validate luôn có 'code')
            if (!obj.edit) obj.edit = {};
            var _ar1 = obj.edit.always_editable_fields instanceof Array ? [...obj.edit.always_editable_fields] : [];
            if (!_ar1.includes('code')) _ar1.push('code');
            var _ar2 = obj.edit.none_validate_fields instanceof Array ? [...obj.edit.none_validate_fields] : [];
            if (!_ar2.includes('code')) _ar2.push('code');
            obj.edit = { ...obj.edit, always_editable_fields: _ar1, none_validate_fields: _ar2 };

            setMainData((v) => Object.assign({}, v, obj));
        },
        [params, props.API, props.prepareConditions, props.header?.prepareConditions, props.isSetting, applyVoucherFlow]
    );

    const load = useCallback(async () => {
        var id = params && params.id ? params.id : mainID.current;
        var code = params && params.code ? params.code : mainCode.current;

        if (!id && !code) return;

        await loadContent({
            recalcable: true
        });
    }, [params, locationPath, loadContent]);

    const autoReload = useCallback(
        (loadNow) => {
            if (loadNow) reload();

            if (autoReloadTimer.current) clearInterval(autoReloadTimer.current);
            autoReloadTimer.current = setInterval(() => {
                reload();
            }, 30 * 1000);
        },
        [reload]
    );

    const postAction = useCallback(
        async (action, code, id) => {
            if (!code) code = mainCode.current;
            if (!id) id = mainID.current;
            if (!id && !code) return;

            if (quickReloadTimeOut.current) clearTimeout(quickReloadTimeOut.current);
            if (autoReloadTimer.current) clearInterval(autoReloadTimer.current);

            let useQuickResponse = session.isSocketConnected();

            // Gửi kèm ngữ cảnh prepare: tuyến nào khai `updatePrepare: true` sẽ trả thẳng
            // phiếu đầy đủ, khỏi phải hỏi lại dấu kiểm tra rồi nạp phiếu thêm một lượt nữa.
            // Màn nào có điều kiện prepare riêng thì KHÔNG đi đường tắt này: phiếu trong phản hồi
            // dựng không kèm điều kiện đó nên có thể khác phiếu do loadContent nạp.
            var hasPrepareConditions = Boolean(
                (props.prepareConditions && Object.keys(props.prepareConditions).length > 0) ||
                    (props.header?.prepareConditions && Object.keys(props.header.prepareConditions).length > 0)
            );
            var actionPrepareOpts = props.isSetting ? { isSetting: true } : undefined;

            var result = await props.API.postAction(action, code, id, useQuickResponse, mainDataRef.current, actionPrepareOpts);
            if (result && result.error) {
                showAlert({
                    content: result.error
                });
            } else {
                // if (action === 'release') await AntTime.sleep(1000 * 2);

                if (props.onActionPosted) props.onActionPosted(action, result);

                if (action === 'delete') {
                    onHomeClick();
                    return;
                }
                if (action === 'close') {
                    if (mainCode.current === code || mainID.current === id) await reload({ refreshMode: 'allPage' });
                    return result;
                }
                if (action === 'print') {
                    return result.data;
                }

                // Phản hồi đã là phiếu đầy đủ do actionUpdatePrepare dựng (tuyến khai
                // `updatePrepare: true`): áp thẳng vào form, khỏi hỏi lại rồi nạp lần nữa.
                var appliedPrepared = false;
                var hasActionFlow = applyVoucherFlow(result?.data);
                if (
                    !hasPrepareConditions &&
                    result?.data &&
                    !(result.data.isQuickResponse && useQuickResponse) &&
                    result.data.actions instanceof Array &&
                    result.data.edit
                ) {
                    appliedPrepared = applyPreparedPayload(result.data);
                }

                if (!appliedPrepared && result?.data) {
                    var isQuickResponse = result.data.isQuickResponse && useQuickResponse;
                    var isStaleQuickResponse =
                        isQuickResponse && result.data.updated_at && dataVersionRef.current && result.data.updated_at <= dataVersionRef.current;
                    if (!isStaleQuickResponse) {
                        setMainData((v) => {
                            if (isQuickResponse) {
                                var merged = Object.assign({}, v, result.data);
                                if (v.actions) merged.actions = v.actions;
                                if (v.edit) merged.edit = v.edit;
                                if (merged.updated_at) dataVersionRef.current = merged.updated_at;
                                return merged;
                            }

                            if (result.data.updated_at) dataVersionRef.current = result.data.updated_at;
                            var next = v.lookups ? { lookups: v.lookups } : {};
                            next.actions = [];
                            next.edit = { isEditable: false, withChildren: [], editable_fields: [] };
                            return Object.assign(next, result.data);
                        });
                    }
                }

                if (!result?.data?.isQuickResponse || !useQuickResponse) {
                    // Đã có phiếu đầy đủ trong phản hồi thì khỏi hỏi lại — trừ khi mất socket,
                    // lúc đó vẫn giữ nhịp đối chiếu dấu kiểm tra để bắt thay đổi chạy nền.
                    if (
                        (!appliedPrepared || !useQuickResponse) &&
                        !(props.flow && !hasActionFlow) &&
                        (mainCode.current === code || mainID.current === id)
                    ) {
                        setTimeout(autoSmartReload, 1000);
                        // await autoSmartReload(false);
                    }
                } else {
                    // Safety net: socket có thể đang báo connected nhưng packet snapshot
                    // bị mất. Snapshot tới bình thường sẽ xoá timer này ngay.
                    quickReloadTimeOut.current = setTimeout(() => {
                        quickReloadTimeOut.current = null;
                        loadContent({ isRefresh: true });
                    }, 1200);
                }

                // Một số action chỉ trả trạng thái phiếu, không kèm voucherFlow.
                // Nạp lại prepare ngay sau action để flow phản ánh chứng từ vừa tạo,
                // thay vì chờ người dùng bấm actionRefresh.
                if (props.flow && !hasActionFlow && (mainCode.current === code || mainID.current === id)) {
                    if (quickReloadTimeOut.current) {
                        clearTimeout(quickReloadTimeOut.current);
                        quickReloadTimeOut.current = null;
                    }
                    await loadContent({ recalcable: true, isRefresh: true, forcePrepare: true, bypassSnapshot: true });
                }
                // await reload({ refreshMode: props.refreshMode });

                // await reload({ refreshMode: 'allPage' });
            }
            return result;
        },
        [
            showAlert,
            props.API,
            props.onActionPosted,
            props.prepareConditions,
            props.header?.prepareConditions,
            props.isSetting,
            props.flow,
            autoSmartReload,
            onHomeClick,
            reload,
            loadContent,
            applyPreparedPayload,
            applyVoucherFlow
        ]
    );

    const onActionCancel = useCallback(async () => {
        if (props.onBeforeAction && (await props.onBeforeAction('cancel')) === false) return;
        let result = await postAction('cancel');
        if (props.onAfterAction) await props.onAfterAction('cancel', result);
    }, [props.onBeforeAction, props.onAfterAction, postAction]);

    const onActionDelete = useCallback(async () => {
        if (props.onBeforeAction) await props.onBeforeAction('delete');
        let result = await postAction('delete');
        if (props.onAfterAction) await props.onAfterAction('delete', result);
    }, [props.onBeforeAction, props.onAfterAction, postAction]);

    const onAction = useCallback(
        async (btn) => {
            if (approvalActionNames.includes(btn?.name)) {
                if (isSaving.current) return;
                if (btn.name === 'actionSubmitApproval' && await saveOnFieldDataChanged() === false) return;
                await postAction(btn.name);
                return;
            }

            if (props.onBeforeAction) await props.onBeforeAction(btn?.name);

            if (props.onAction) {
                let result = await props.onAction(btn);
                if (props.onAfterAction) await props.onAfterAction(btn?.name, result);

                return result;
            }
        },
        [props.onBeforeAction, props.onAction, postAction, saveOnFieldDataChanged]
    );

    const onActionRelease = useCallback(async () => {
        // resetDisabled(true);
        if (props.onBeforeAction && (await props.onBeforeAction('release')) === false) return;
        let result = await postAction('release');
        if (props.onAfterAction) await props.onAfterAction('release', result);
    }, [props.onBeforeAction, props.onAfterAction, postAction]);

    const onActionClose = useCallback(async () => {
        // resetDisabled(true);
        if (props.onBeforeAction) await props.onBeforeAction('close');
        let result = await postAction('close');
        if (props.onAfterAction) await props.onAfterAction('close', result);
    }, [props.onBeforeAction, props.onAfterAction, postAction]);

    const onActionPost = useCallback(async () => {
        if (props.onBeforeAction) await props.onBeforeAction('post');
        let result = await postAction('post');
        if (props.onAfterAction) await props.onAfterAction('post', result);
    }, [props.onBeforeAction, props.onAfterAction, postAction]);

    const onActionApprove = useCallback(async () => {
        if (props.onBeforeAction && (await props.onBeforeAction('approve')) === false) return;
        let result = await postAction('approve');
        if (props.onAfterAction) await props.onAfterAction('approve', result);
    }, [props.onBeforeAction, props.onAfterAction, postAction]);

    const onActionReject = useCallback(async () => {
        if (props.onBeforeAction && (await props.onBeforeAction('reject')) === false) return;
        let result = await postAction('reject');
        if (props.onAfterAction) await props.onAfterAction('reject', result);
    }, [props.onBeforeAction, props.onAfterAction, postAction]);

    const onActionPrint = useCallback(
        async (strTemplate, options = {}) => {
            const preparedPrinter = props.printComponent?.current || printer.current;
            if (options.preparedData?.html && typeof preparedPrinter?.load === 'function') {
                await preparedPrinter.load(options.preparedData);
                return true;
            }
            if (props.printComponent && props.printComponent.current && typeof props.printComponent.current.load === 'function') {
                var data = await postAction('print');
                await props.printComponent.current.load(data);
            } else if (props.printUrl && printer.current) {
                if (props.service === 'AROrder') {
                    var delivery = await props.API.postAsync('/ar/AROrder/remotePrint', {
                        code: params?.code,
                        id: params?.id,
                        template: typeof strTemplate === 'string' ? strTemplate : undefined
                    });
                    var deliveryData = delivery && delivery.data ? delivery.data : delivery;
                    if (deliveryData?.dispatched === true) return true;
                    if (deliveryData?.print_data?.html) {
                        await printer.current.load(deliveryData.print_data);
                        return true;
                    }
                    // The delivery API owns fallback. Never bypass its error or
                    // permission result with a second generateBillHTML request.
                    return false;
                }
                var body = {
                    code: params && params.code ? params.code : undefined,
                    id: params && params.id ? params.id : undefined,
                    template: strTemplate
                };

                var data = await props.API.postAsync(props.printUrl, body);
                if (data && !data.error) printer.current.load(data.data);

                // props.API.post(props.printUrl, body, (data) => {
                //     printer.current.load(data.data);
                // });
            }
        },
        [props.printComponent, props.printUrl, props.API, props.service, postAction]
    );

    const onActionRecalculate = useCallback(async () => {
        await postAction('recalculate');
    }, [postAction]);

    const onPrintClick = useCallback(() => {
        onActionPrint();
    }, [onActionPrint]);

    const onRecalculateClick = useCallback(() => {
        onActionRecalculate();
    }, [onActionRecalculate]);

    useEffect(() => {
        mainCode.current = null;
        AntAuth.checkValidSession();
        if (props.onPrinted && props.toolbar && props.toolbar.showPrint && ((props.printComponent && props.printComponent.current) || props.printUrl))
            window.addEventListener('afterprint', props.onPrinted);

        return () => {
            markVoucherViewed(mainCode.current || mainID.current);
            if (autoReloadTimer.current) clearInterval(autoReloadTimer.current);
            if (quickReloadTimeOut.current) clearTimeout(quickReloadTimeOut.current);

            if (
                props.onPrinted &&
                props.toolbar &&
                props.toolbar.showPrint &&
                ((props.printComponent && props.printComponent.current) || props.printUrl)
            )
                window.removeEventListener('afterprint', props.onPrinted);

            delete header.current;
            delete footer.current;
            delete tabs.current;
            delete msgBox.current;
            mainCode.current = null;
            mainID.current = null;
            header.current = null;
            footer.current = null;
            tabs.current = null;
            msgBox.current = null;
        };
    }, []);

    useEffect(() => {
        // Đổi phiếu → DỪNG mọi timer reload cũ (chúng ôm mã phiếu trước, sẽ reload nhầm).
        var stopStaleReloaders = () => {
            if (autoReloadTimer.current) clearInterval(autoReloadTimer.current);
            if (quickReloadTimeOut.current) {
                clearTimeout(quickReloadTimeOut.current);
                quickReloadTimeOut.current = null;
            }
            if (socketReloadTimerRef.current) {
                clearTimeout(socketReloadTimerRef.current);
                socketReloadTimerRef.current = null;
            }
        };
        if (params.code && params.code !== mainCode.current) {
            loadSeqRef.current = (loadSeqRef.current || 0) + 1;
            dataVersionRef.current = null;
            mainCode.current = params.code;
            setBootCode(shouldShowBootSkeleton(params.code) ? String(params.code) : null);
            stopStaleReloaders();
            load();
        } else if (params.id && params.id !== mainID.current) {
            loadSeqRef.current = (loadSeqRef.current || 0) + 1;
            dataVersionRef.current = null;
            mainID.current = params.id;
            setBootCode(shouldShowBootSkeleton(params.id) ? String(params.id) : null);
            stopStaleReloaders();
            load();
        }
    }, [params]);

    useImperativeHandle(ref, () => ({
        showPopup: showPopup,
        postAction: postAction,
        load: load,
        autoReload: () => autoSmartReload(true),
        getFormData: () => mainData,
        runPrint: onActionPrint,
        showAIAnalyzer: showAIAnalyzer
    }));
    // let strBusName = AntAuth.getSessionInfo('business_name');
    // var logo = appGlobal.appAssets && appGlobal.appAssets.images.logoWithBrand ? appGlobal.appAssets.images.logoWithBrand : undefined;

    const onRefreshClick = useCallback(async () => {
        await loadContent({ recalcable: true, isRefresh: true, forcePrepare: true, bypassSnapshot: true });
        requestAnimationFrame(() => tabs.current?.reload?.({ forceQuery: true, byPassGetCache: true }));
    }, [loadContent]);

    const onActionProcessing = useCallback(
        (btn) => {
            if (btn?.name === 'showSwitchUI') {
                var uiData = localStorage.getItem(cs.System_Code + '-ui-states');
                if (uiData) uiData = JSON.parse(uiData);
                if (!uiData) uiData = {};

                localStorage.setItem(
                    cs.System_Code + '-ui-states',
                    String(
                        stringify({
                            ...uiData,
                            mode: 'POSUI'
                        })
                    )
                );
                if (mainData.code) navigate(props.switchModeURL + '/' + mainData.code);
                else navigate('/home');

                window.location.reload();
            }
            if (props.onActionProcessing) props.onActionProcessing(btn);

            setMainState((v) =>
                Object.assign(v, {
                    toolbarProcessingButton: btn.name
                })
            );
        },
        [mainData, props.onActionProcessing]
    );

    const onActionProceeed = useCallback(() => {
        setMainState((v) =>
            Object.assign(v, {
                toolbarProcessingButton: null
            })
        );
    }, []);

    // Cập nhật NHANH vùng tổng tiền từ payload socket (BE đính totals + updated_at
    // vào event *-Recalculated) — 0 lời gọi API, header/footer re-render tại chỗ,
    // grid items + actions GIỮ NGUYÊN → hết nháy toàn màn.
    const applySummaryPayload = useCallback((d) => {
        if (!d || !d.totals || Object.keys(d.totals).length === 0) return false;
        if (d.updated_at && dataVersionRef.current && d.updated_at < dataVersionRef.current) return true; // bản cũ → bỏ nhưng coi như đã xử lý
        if (d.updated_at) dataVersionRef.current = d.updated_at;
        setMainData((v) => {
            if (!v || !v.id) return v;
            var merged = Object.assign({}, v, d.totals);
            if (d.updated_at) merged.updated_at = d.updated_at;
            return merged;
        });
        return true;
    }, []);

    const onSocketReceived = useCallback(
        (data, screenName) => {
            if (data?.byPassOfficeMode) return false;

            // Nối lại mạng: tin phát trong lúc đứt đã mất → tải lại phiếu đang mở
            var isReconnected = data?.event === 'SOCKET_RECONNECTED';
            var currentParams = paramsRef.current || params;
            var isCurrentVoucher =
                mainTable === data?.name &&
                ((data?.data?.code && (currentParams.code === data.data.code || mainCode.current === data.data.code)) ||
                    (data?.data?.id && String(mainID.current) === String(data.data.id)));

            if (isReconnected || isCurrentVoucher) {
                var scheduleSocketReload = () => {
                    if (socketReloadTimerRef.current) clearTimeout(socketReloadTimerRef.current);
                    socketReloadTimerRef.current = setTimeout(() => {
                        socketReloadTimerRef.current = null;
                        loadContent(props.flow
                            ? { isRefresh: true, forcePrepare: true, bypassSnapshot: true, refreshChildrenOnUnchanged: true }
                            : { isRefresh: true, refreshChildrenOnUnchanged: true });
                    }, 400);
                };
                // Cập nhật totals ngay; phiếu có flow còn cần prepare lại vì chứng từ con có thể vừa thay đổi.
                var isRecalculated = !isReconnected && data.event === mainTable + '-Recalculated';
                if (isRecalculated && applySummaryPayload(data.data)) {
                    if (props.flow) scheduleSocketReload();
                    return;
                }

                // Quick action mang full snapshot hoặc delta có revision. Áp thành công
                // thì đây đã là snapshot BE chuẩn bị đầy đủ, không cần gọi API đối chiếu.
                if (!isReconnected && applyPreparedPayload(data.data)) {
                    if (quickReloadTimeOut.current) {
                        clearTimeout(quickReloadTimeOut.current);
                        quickReloadTimeOut.current = null;
                    }
                    if (props.flow && !Object.prototype.hasOwnProperty.call(data.data || {}, 'voucherFlow')) scheduleSocketReload();
                    return;
                }

                if (quickReloadTimeOut.current) {
                    clearTimeout(quickReloadTimeOut.current);
                    quickReloadTimeOut.current = null;
                }

                // Sự kiện khác (đổi trạng thái, sửa dòng...) → gộp nhiều event trong 400ms
                // thành 1 lần reload (loadContent đã có chốt thứ tự + chặn bản cũ)
                scheduleSocketReload();
            }
        },
        [loadContent, params, applySummaryPayload, applyPreparedPayload, props.flow]
    );

    useEffect(() => {
        session.clearSocketListener(mainTable);
        session.registerSocketListener(onSocketReceived, mainTable);

        return () => {
            session.clearSocketListener(mainTable);
            if (socketReloadTimerRef.current) {
                clearTimeout(socketReloadTimerRef.current);
                socketReloadTimerRef.current = null;
            }
        };
    }, [locationPath, loadContent, params]);

    // ─── Silent application/x-meddoc drop on voucher body ────────
    // Khi user drag file từ MEDExplorerPanel thả vào main body voucher
    // (ngoài leftSidebar) → BE silently analyze + auto-apply.
    const isInsideLeftSidebar = useCallback((target) => {
        var el = target;
        while (el && el !== voucherContentRef.current) {
            if (el.classList && el.classList.contains('ant-left-sidebar')) return true;
            el = el.parentElement;
        }
        return false;
    }, []);

    useEffect(() => {
        var node = voucherContentRef.current;
        if (!node) return undefined;

        var allowDrop = function (e) {
            if (
                !e.dataTransfer ||
                !e.dataTransfer.types ||
                Array.prototype.indexOf.call(e.dataTransfer.types, 'application/x-meddoc') < 0
            )
                return;
            if (isInsideLeftSidebar(e.target)) return;
            e.preventDefault();
            try {
                e.dataTransfer.dropEffect = 'copy';
            } catch (err) {
                /* silent */
            }
        };

        var handleSilentDrop = function (e) {
            if (
                !e.dataTransfer ||
                !e.dataTransfer.types ||
                Array.prototype.indexOf.call(e.dataTransfer.types, 'application/x-meddoc') < 0
            )
                return;
            if (isInsideLeftSidebar(e.target)) return;
            e.preventDefault();

            // Voucher editable check
            var status = mainData && (mainData.status || mainData.state);
            if (status && ['New', 'Pending'].indexOf(status) < 0) return;

            // Need AI extract context
            if (!mainData || !mainData.aiExtract || !mainData.aiExtract.enabled) return;
            var aiExtract = mainData.aiExtract;
            if (!aiExtract.target_table || !aiExtract.target_id) return;

            try {
                var payload = JSON.parse(e.dataTransfer.getData('application/x-meddoc'));
                var aiAPI = new AntAPI('ai', 'AIVoucherAnalysis');
                aiAPI.post(
                    '/' + aiAPI.routeURL + '/actionAnalyzeForVoucher',
                    {
                        target_table: aiExtract.target_table,
                        target_code: aiExtract.target_code,
                        target_id: aiExtract.target_id,
                        med_doc_code: payload.document_code,
                        med_doc_id: payload.document_id,
                        intent: 'UpdateExisting',
                        source_channel: 'Toolbar',
                        run_mode: 'async',
                        auto_apply: true,
                        auto_release: false
                    },
                    function () {
                        /* silent — toast/feedback via socket event */
                    }
                );
            } catch (err) {
                console.error('[AntVoucher silent x-meddoc drop] error:', err && err.message);
            }
        };

        node.addEventListener('dragover', allowDrop);
        node.addEventListener('drop', handleSilentDrop);
        return function () {
            node.removeEventListener('dragover', allowDrop);
            node.removeEventListener('drop', handleSilentDrop);
        };
    }, [mainData, isInsideLeftSidebar]);

    return (
        <AntGridScope segment={buildGridScopeSegment('voucher', mainTable)}>
            {isRender && (
                <AntPage
                    className={'ant-voucher-page'}
                    marginLeft={10}
                    marginRight={10}
                    marginBottom={props.marginBottom ? props.marginBottom : 5}
                    backgroundImage={props.backgroundImage}
                    hideBackgroundImage={renderLoading || renderAccessDenied || renderNotExistData}
                >
                    {/* <ReactToPrint content={props.printComponent}>
                        <PrintContextConsumer>
                            {({ runPrint }) => (
                                
                            )}
                        </PrintContextConsumer>
                    </ReactToPrint> */}

                    <AntToolbar
                        API={props.API}
                        table={props.table}
                        shouldRender={isRender}
                        parentData={mainData}
                        renderParent={Boolean(isRenderPage && !isInValidData && isPrepared.current)}
                        // renderParent={isRenderPage && !isInValidData && isPrepared.current}
                        title={props.title ? AntLocalization.translateText(props.title) : AntLocalization.translateText(mainEntityDisplay)}
                        titleIcon={props.titleIcon}
                        processingButton={mainState.toolbarProcessingButton}
                        showBack={true}
                        showHome={true}
                        showHelp={props.toolbar ? props.toolbar.showHelp : false}
                        showRefresh={true}
                        showSwitchUI={
                            props.switchModeURL
                                ? (String(props.switchModeURL).indexOf('/pos/') === 0 ? AntCondition.canUsePOS() : true)
                                : false
                        }
                        showPrint={props.toolbar ? props.toolbar.showPrint : false}
                        showRecalculate={props.toolbar?.showRecalculate !== undefined ? props.toolbar.showRecalculate : true}
                        showActions={props.toolbar ? props.toolbar.showActions : undefined}
                        actionPack={props.toolbar ? props.toolbar.actionPack : undefined}
                        items={props.toolbar ? props.toolbar.items : undefined}
                        onRefreshClick={onRefreshClick}
                        onHomeClick={onHomeClick}
                        onPrintClick={onPrintClick}
                        onRecalculateClick={onRecalculateClick}
                        onActionQuickCreate={onActionQuickCreate}
                        onActionClone={onActionClone}
                        onActionCancel={onActionCancel}
                        onActionDelete={onActionDelete}
                        onActionRelease={onActionRelease}
                        onActionClose={onActionClose}
                        onActionPost={onActionPost}
                        onActionApprove={onActionApprove}
                        onActionReject={onActionReject}
                        onActionUpdateWithDoc={onActionUpdateWithDoc}
                        onAction={onAction}
                        onActionProcessing={onActionProcessing}
                        onActionProceeed={onActionProceeed}
                        actionRelease={props.actionRelease}
                        actionCancel={props.actionCancel}
                        actionPost={props.actionPost}
                        flowToggle={
                            props.flow
                                ? { visible: flowVisible, hasData: flowData && flowData.nodes && flowData.nodes.length > 1, onClick: onToggleFlow }
                                : undefined
                        }
                    />

                    {mainData && mainData.aiExtract && mainData.aiExtract.enabled && (
                        <AntAIVoucherAnalyzer
                            ref={aiAnalyzerRef}
                            session={props.session}
                            targetTable={mainData.aiExtract.target_table}
                            targetId={mainData.aiExtract.target_id}
                            targetCode={mainData.aiExtract.target_code}
                            modeOptions={mainData.aiExtract.mode_options}
                            costHints={mainData.aiExtract.cost_hints}
                            onApplied={() => load && load()}
                        />
                    )}

                    {renderAccessDenied && (
                        <AntErrorPage
                            id={`ant-voucher-error-page-${props.API.entityName}`}
                            text={AntLocalization.translateText({
                                vi: 'Không có quyền truy cập !',
                                en: 'Access Denied',
                                fr: 'Accès refusé',
                                es: 'Acceso denegado',
                                id: 'Akses ditolak',
                                ja: 'アクセス拒否',
                                zh: '访问被拒绝',
                                ko: '접근 거부',
                                hi: 'पहुँच अस्वीकृत',
                                ar: 'تم رفض الوصول'
                            })}
                        />
                    )}
                    {isRenderPage && !isPermDeniedData && (
                        <div className="ant-voucher-workspace">
                            {/* Sidebar là sibling ổn định: BrowsePanel không bị ẩn/tháo cùng content khi đổi phiếu. */}
                            {(!props.leftSidebar || props.leftSidebar.enabled !== false) && (
                                <AntLeftSidebar
                                    ref={leftSidebarRef}
                                    variant={(props.leftSidebar && props.leftSidebar.variant) || 'voucher'}
                                    data={leftSidebarData}
                                    panels={props.leftSidebar && props.leftSidebar.panels}
                                    browseConfig={props.leftSidebar && props.leftSidebar.browseTab}
                                    mockMode={props.leftSidebar && props.leftSidebar.mockMode}
                                />
                            )}
                            <div id={'ant-voucher-main-' + mainEntityName} className="ant-voucher-main">
                                {renderBootSkeleton && (
                                    <AntVoucherSkeleton
                                        showHeader={Boolean(props.header && props.header.items instanceof Array && props.header.items.length > 0)}
                                        tabs={props.tabs instanceof Array && props.tabs.length > 0 ? props.tabs.length : 4}
                                    />
                                )}
                                {renderLoading && !renderBootSkeleton && (
                                    <div>
                                        <LoadPanel
                                            container={'#ant-voucher-main-' + mainEntityName}
                                            position={{ of: '#ant-voucher-main-' + mainEntityName }}
                                            visible={true}
                                            showPane={false}
                                            shading={true}
                                            // shadingColor={'rgba(119, 119, 128, 0.16)'}
                                            wrapperAttr={{
                                                class: 'ant-loading'
                                            }}
                                            // indicatorSrc={'https://image.flaticon.com/icons/svg/3305/3305803.svg'}
                                        />
                                    </div>
                                )}
                                {renderNotExistData && (
                                    <AntErrorPage
                                        errors={mainState.error ? mainState.error.values : undefined}
                                        id={`ant-voucher-error-page-${props.API.entityName}`}
                                        text={
                                            mainState.error
                                                ? AntLocalization.translateText(mainState.error.text)
                                                : {
                                                      vi: 'Dữ liệu không tồn tại !',
                                                      en: 'Data not found !',
                                                      fr: 'Données introuvables !',
                                                      es: '¡Datos no encontrados!',
                                                      id: 'Data tidak ditemukan !',
                                                      ja: 'データが存在しません！',
                                                      zh: '数据不存在！',
                                                      ko: '데이터가 없습니다!',
                                                      hi: 'डेटा मौजूद नहीं है !',
                                                      ar: 'البيانات غير موجودة !'
                                                  }
                                        }
                                    />
                                )}
                                <div
                                    ref={voucherContentRef}
                                    className={'ant-voucher-content'}
                                    style={{
                                        display: isVisiblePage && isPrepared.current ? 'flex' : 'none',
                                        flexDirection: 'row',
                                        flex: 1,
                                        ...(props.contentWidth ? { maxWidth: props.contentWidth } : {})
                                    }}
                                >
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                {/* <p /> */}
                                {isVisibleHeader && (
                                    <AntBaseForm
                                        ref={header}
                                        shouldRender={isRender}
                                        API={props.API}
                                        type={'Update'}
                                        formData={mainData}
                                        formTable={mainTable}
                                        oldData={mainState.oldData}
                                        table={props.header && props.header.table ? props.header.table : props.table}
                                        alignItemLabelsInAllGroups={props.header ? props.header.alignItemLabelsInAllGroups : undefined}
                                        labelLocation={props.header ? props.header.labelLocation : undefined}
                                        colCount={props.header && props.header.colCount !== undefined ? props.header.colCount : 1}
                                        colCountDefault={props.header ? props.header.colCountDefault : undefined}
                                        fields={props.header && props.header.fields ? props.header.fields : []}
                                        items={props.header && props.header.items ? props.header.items : []}
                                        postFields={props.header ? props.header.postFields : undefined}
                                        currencyField={props.header && props.header.currencyField !== undefined ? props.header.currencyField : props.currencyField}
                                        onFieldDataChanged={onFieldDataChanged}
                                        prepareConditions={props.header ? props.header.prepareConditions : undefined}
                                        onError={setError}
                                        visible={isVisiblePage}
                                        isSearching={props.header ? props.header.isSearching : undefined}
                                        disabled={mainState.toolbarProcessingButton ? true : props.header ? props.header.disabled : undefined}
                                        renderFooter={props.header ? props.header.renderFooter : undefined}
                                        hideFormFields={
                                            props.header && props.header.hideFormFields !== undefined
                                                ? typeof props.header.hideFormFields === 'function'
                                                    ? props.header.hideFormFields(mainData)
                                                    : props.header.hideFormFields
                                                : undefined
                                        }
                                        keepFormFields={
                                            props.header && props.header.keepFormFields !== undefined
                                                ? typeof props.header.keepFormFields === 'function'
                                                    ? props.header.keepFormFields(mainData)
                                                    : props.header.keepFormFields
                                                : undefined
                                        }
                                        onUploaded={handleUploaded}
                                        onGenerateQueued={() => {
                                            setMainData((data) => ({ ...(data || {}), avatar_generating: true }));
                                            loadContent();
                                        }}
                                        // onContentReady={(e) => {
                                        //     setTimeout(() => {
                                        //         this.autoFocusAfterReady();
                                        //     }, 2000);
                                        // }}
                                    />
                                )}
                                {isVisibleHeader && <p style={{ marginBlockStart: '0px', marginBlockEnd: '10px' }} />}
                                {mainState.error && (
                                    <div className={'ant-voucher-error-container'}>
                                        <AntErrorPanel
                                            errors={mainState.error.values}
                                            id={`ant-voucher-error-${props.API.entityName}`}
                                            text={mainState.error.text}
                                            hasBackground={true}
                                        />
                                        {isVisibleHeader && <p style={{ marginBlockStart: '0px', marginBlockEnd: '10px' }} />}
                                    </div>
                                )}

                                {mainInfos.length > 0 && <p style={{ marginBlockStart: '0px', marginBlockEnd: '10px' }} />}
                                {mainInfos.map((info, i) => {
                                    if (info.type === 'Warning' || info.type === 'Error')
                                        return (
                                            <div key={'ant-voucher-error-container-' + i} className={'ant-voucher-error-container'}>
                                                <AntErrorPanel
                                                    id={`ant-voucher-error-${props.API.entityName}` + '-' + i}
                                                    text={info.message}
                                                    hasBackground={true}
                                                />
                                                {<p style={{ marginBlockStart: '0px', marginBlockEnd: '10px' }} />}
                                            </div>
                                        );

                                    return (
                                        <div className={'ant-voucher-info-container'}>
                                            <AntInfoPanel
                                                id={`ant-voucher-info-${props.API.entityName}` + '-' + i}
                                                text={info.message}
                                                showYes={info.agreeable}
                                                onAgreeClick={(e, done) => {
                                                    if (props.onInfoAgree) props.onInfoAgree(info, done);
                                                }}
                                            />
                                            {<p style={{ marginBlockStart: '0px', marginBlockEnd: '10px' }} />}
                                        </div>
                                    );
                                })}
                                {props.flow && flowData && flowData.nodes && flowData.nodes.length > 1 && (
                                    <div className={`ant-voucher-flow-container${!flowVisible ? ' collapsed' : ''}`}>
                                        <AntVoucherFlow
                                            flowData={flowData}
                                            currentNode={props.flow.currentNode || (props.API ? props.API.entityName : undefined)}
                                            currentCode={mainCode.current}
                                            height={props.flow.height || 140}
                                            showExpected={props.flow.showExpected !== false}
                                            showMeta={props.flow.showMeta !== false}
                                            compact={props.flow.compact || false}
                                            configOverride={props.flow.configOverride}
                                            accessScreens={props.session && props.session.settings && props.session.settings.access_screens}
                                            onNodeClick={(node) => {
                                                if (props.flow.onNodeClick) {
                                                    props.flow.onNodeClick(node);
                                                } else {
                                                    let drilldown = getDrilldown(node.type);
                                                    let _drillUrl = node.drilldownUrl || drilldown.url;
                                                    let _as = props.session && props.session.settings && props.session.settings.access_screens;
                                                    let _hasAccess =
                                                        !drilldown.whenUserScreen ||
                                                        !_as ||
                                                        !Array.isArray(_as) ||
                                                        _as.length === 0 ||
                                                        _as.includes(drilldown.whenUserScreen);
                                                    if (
                                                        !node.disabled &&
                                                        !node.noAccess &&
                                                        _hasAccess &&
                                                        _drillUrl &&
                                                        node.existence === 'exists' &&
                                                        node.code
                                                    ) {
                                                        if (drilldown.openInNewTab) window.open(_drillUrl + node.code, '_blank');
                                                        else navigate(_drillUrl + node.code);
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                                {typeof props.contentRender === 'function' && (
                                    <div className="ant-voucher-custom-content">
                                        {props.contentRender({
                                            data: mainData,
                                            session: session,
                                            reload: reload,
                                            postAction: postAction,
                                            actionProcessing: !!mainState.toolbarProcessingButton
                                        })}
                                    </div>
                                )}
                                {props.tabs instanceof Array && props.tabs.length > 0 && (
                                    <div style={{ visibility: isVisiblePage ? 'visible' : 'hidden', marginTop: '10px', marginBottom: '10px' }}>
                                        <AntVoucherTabs
                                            ref={tabs}
                                            shouldRender={isRender}
                                            API={props.API}
                                            formData={mainData}
                                            formTable={mainTable}
                                            oldData={mainState.oldData}
                                            tabs={props.tabs}
                                            currencyField={props.currencyField}
                                            tabStyle={mainState.tabStyle}
                                            tabHeight={props.tabHeight}
                                            autoExpandAll={props.tabAutoExpandAll}
                                            groupCollapsible={props.tabCollapsible}
                                            groupExpandMultiple={props.tabExpandMultiple}
                                            autoHideTitle={props.tabAutoHideTitle}
                                            onFieldDataChanged={onFieldDataChanged}
                                            onDataSourceEdited={props.fullReloadOnDataEdited ? reload : refreshVoucherSummary}
                                            onAfterAction={reload}
                                            onBarcodeScanned={props.onBarcodeScanned}
                                            // onBarcodeScanned={reload}
                                            onError={setError}
                                            visible={isVisiblePage}
                                            disabled={mainState.toolbarProcessingButton ? true : undefined}
                                        />
                                    </div>
                                )}
                                {isVisibleFooter && props.tabs.length > 0 && <p style={{ marginBlockStart: '0px', marginBlockEnd: '50px' }} />}
                                {isVisibleFooter && (
                                    <AntBaseForm
                                        ref={footer}
                                        shouldRender={isRender}
                                        API={props.API}
                                        type={'Update'}
                                        formData={mainData}
                                        formTable={mainTable}
                                        oldData={mainState.oldData}
                                        table={props.footer && props.footer.table ? props.footer.table : props.table}
                                        alignItemLabelsInAllGroups={props.footer ? props.footer.alignItemLabelsInAllGroups : undefined}
                                        labelLocation={props.footer ? props.footer.labelLocation : undefined}
                                        colCount={props.footer && props.footer.colCount !== undefined ? props.footer.colCount : 1}
                                        colCountDefault={props.footer ? props.footer.colCountDefault : undefined}
                                        fields={props.footer && props.footer.fields !== undefined ? props.footer.fields : []}
                                        items={props.footer && props.footer.items !== undefined ? props.footer.items : []}
                                        postFields={props.footer ? props.footer.postFields : undefined}
                                        currencyField={props.footer && props.footer.currencyField !== undefined ? props.footer.currencyField : props.currencyField}
                                        onFieldDataChanged={onFieldDataChanged}
                                        onError={setError}
                                        visible={isVisiblePage}
                                        isSearching={props.footer ? props.footer.isSearching : undefined}
                                        disabled={mainState.toolbarProcessingButton ? true : props.footer ? props.footer.disabled : undefined}
                                        renderFooter={props.footer ? props.footer.renderFooter : undefined}
                                        onUploaded={handleUploaded}
                                        onGenerateQueued={() => {
                                            setMainData((data) => ({ ...(data || {}), avatar_generating: true }));
                                            loadContent();
                                        }}
                                    />
                                )}
                                <AntMessageBox ref={msgBox} />
                                {/* <p style={{ marginBlockStart: '0px', marginBlockEnd: '10px' }} /> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </AntPage>
            )}
            {props.children}
            {/* {React.Children.map(props.children, (child) => {
                return React.cloneElement(child, {});
            })} */}
            <div style={{ display: 'none' }}>
                <AntPrinting ref={printer} appGlobal={appGlobal} onReady={handlePrint} />
            </div>
        </AntGridScope>
    );
});
